import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "stage" }
const _hoisted_2 = { class: "stage-inner" }
const _hoisted_3 = { class: "lead" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "goal" }
const _hoisted_6 = { class: "benefits" }
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "card cta" }
const _hoisted_11 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_button = _resolveComponent("app-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"blobs\" aria-hidden=\"true\" data-v-2b89cc62><span class=\"blob b1\" data-v-2b89cc62></span><span class=\"blob b2\" data-v-2b89cc62></span><span class=\"blob b3\" data-v-2b89cc62></span><span class=\"blob b4\" data-v-2b89cc62></span></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("p", { class: "kicker" }, "Rainbow Manager", -1)),
      _createElementVNode("h1", null, _toDisplayString(_ctx.t('consultation')), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.t('revealYourInherentElegance')), 1),
      _createElementVNode("article", _hoisted_4, [
        _createElementVNode("p", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.t('haveYouEverContemplated')), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.t('whyCertainHues')), 1)
        ]),
        _createElementVNode("p", null, _toDisplayString(_ctx.t('greedy')), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.t('myGoal')), 1)
      ]),
      _createElementVNode("h2", null, _toDisplayString(_ctx.t('whatWilGain')), 1),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("article", _hoisted_7, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.t('recoveredTime')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.t('youWillCeaseAcquiring')), 1)
        ]),
        _createElementVNode("article", _hoisted_8, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.t('assuredSelection')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.t('youWillPossessPreciseClarity')), 1)
        ]),
        _createElementVNode("article", _hoisted_9, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.t('cohesiveHarmonious')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.t('youWillAppearMore')), 1)
        ])
      ]),
      _createElementVNode("article", _hoisted_10, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.t('bidFarewell')), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.t('togetherWeWillDiscover')), 1),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_app_button, {
            icon: ['fas', 'eye'],
            title: "demoLookbook",
            onClick: _ctx.openPdfModal
          }, null, 8, ["onClick"]),
          _createVNode(_component_app_button, {
            raised: "",
            severity: "gradient",
            icon: ['fab', 'telegram'],
            title: "connectViaTelegram",
            onClick: _ctx.openTelegram
          }, null, 8, ["onClick"])
        ])
      ])
    ])
  ]))
}